export const TRANSLATIONS_EN = {
    actions: "Actions",
    cronicle: "Cronicle",
    members: "Members",
    contact: "Contact",
    commercials: "Commercials",

    place: "Place",
    chairman: "Chairman",
    vicechairman: "Vice-Chairman",
    treasurer: "Treasurer",
    quickContact: "Quick Contact",
    hide: "Hide",
    read: "Read",
    readAll: "Read all",
    showAll: "Show all",
    
    membersMessage: "These are persons, who take care of your children.",
    cronicleMessage: "This arcticles saves out memories.",
    contactMessage: "The most importent person in KELT. Feel free to ask them.",
    commercialsMessage: "Now you can view aour free times.",

    //login
    loginTitle: "Login",
    username: "Username",
    password: "Password",
    login: "Log in",
    loginBtn: "Log in",
    loginError: "Login failed",
    invalidCredentials: "Invalid username or password",
    loginRequired: "Login required",
    close: "Close",
    logout: "Logout",
    signup: "Sign Up",
    edit: "Edit",
    send: "Send",
    rental: "Rental",
    scheduler: "Scheduler",
    position: "Place",
    lastTime: "Last time",
    search: "Search",
    detail: "Detail",
    rentier: "Rentier",
    from: "From",
    to: "To",
    save: "Save",
    new: "New",
    next: "Next",

    actionName: "Action Name",
    actionPlace: "Action Place",
    actionText: "Action Text",
    actionPrice: "Action Price",
    showDecription: "Show Description",

    digitalSignup: "Digital Signup",
    digitalSignupMessage: "Sign in 3 steps",   
    chooseAction: "1. Select Action",
    enterCaptcha: "2. Enter captcha",
    enterForm: "3. Enter Form",
    confirmForm: "4. Check data",
    preview: "Preview",
    confirm: "Confirm",

    captchaAlert: "Captcha Does Not Match",
    captchaPlaceholder: "Enter Captcha Value",
    reloadText: "Reload My Captcha",
    submit: "Submit",

    navToogle: "Toggle navigation",
    about: "About user",
    nick: "Nick",
    func: "Skills",
    moto: "Moto",
    text: "Text",
    email: "E-mail",
    birthDay: "Birthday",
    nameDay: "Day of the name",
    docs: "Documents",
    fotogalery: "Fotogalery",

    dashboard: "Dashboard",
    dashboardMessage: "Everything you have to known.",

    showHidden: "Show hidden",
    showEditor: "Show editor",
    dashboardName: "Title",
    dashboardVisibility: "Visible?",
    dashboardText: "Message",
    lastUpdate: "Last change",

    signupList: "Signup list",
    created: "Created",    
    firstName: "First Name",
    lastName: "Last Name",
    birthNumber: "Birth Number",
    tShirtSize: "T-shirt size",
    address: "Address",
    parentName: "Parent Name",
    parentPhone: "Parent Phone",
    parentEmail: "Parent Email",
    note: "Note",

    add: "Add NEW",
    rent: "RENT",
    back: "BACK",
    rentFREE: "FREE",
    rentRENTED: "RENTED",
    rentName: "Name",
    rentDescription: "Description",
    rentPlace: "Place",
    rentState: "State of Rent",
    rentLastRentier: "Last Rentier",
    rentValid: "Fill the Rentier",
    rentalDateShow: "Set date manualy?",

    all: "All",
    selectYear: "Select Year",
    selectAction: "Select Action",
    ExportToPDF : "Export to PDF",
    ExportToXLSX: "Export to XLSX",

    songBook: "Song Book",
    songMessage: "Kelťs song book",
};
